import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import axios from "axios";
import { useLang } from "@/App";
import { copy, LOGO } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShopSuccess() {
    const { lang } = useLang();
    const c = copy[lang].shop;
    const [params] = useSearchParams();
    const [state, setState] = useState("checking");

    useEffect(() => {
        const sid = params.get("session_id");
        if (!sid) {
            setState("timeout");
            return;
        }
        let n = 0;
        const t = setInterval(async () => {
            n++;
            try {
                const res = await axios.get(`${API}/shop/status/${sid}`);
                if (res.data.payment_status === "paid") {
                    setState("paid");
                    clearInterval(t);
                } else if (n > 15) {
                    setState("timeout");
                    clearInterval(t);
                }
            } catch {
                if (n > 15) {
                    setState("timeout");
                    clearInterval(t);
                }
            }
        }, 2000);
        return () => clearInterval(t);
    }, [params]);

    return (
        <div data-testid="shop-success-page" className="min-h-screen bg-noir flex items-center justify-center px-4">
            <div className="max-w-md w-full text-center rounded-2xl border border-brass/25 bg-card p-10">
                <img src={LOGO} alt="The Market Lugano" className="h-10 w-auto mx-auto mb-8" />
                {state === "checking" ? (
                    <>
                        <Loader2 size={40} className="animate-spin text-crimson mx-auto" />
                        <p className="mt-6 text-neutral-300">{c.checking}</p>
                    </>
                ) : (
                    <>
                        <CheckCircle2 size={48} className="text-emerald-400 mx-auto" />
                        <h1 className="mt-6 font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl">
                            {c.successTitle}
                        </h1>
                        <p className="mt-4 text-neutral-400 text-sm leading-relaxed">{c.successText}</p>
                        <Link
                            data-testid="success-home-link"
                            to="/"
                            className="mt-8 inline-flex items-center justify-center rounded-full bg-crimson hover:bg-crimson-bright transition-colors text-white text-xs font-bold uppercase tracking-widest px-7 py-3.5"
                        >
                            {c.back}
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
}
